export const charge = {
  status: {
    applied: "applied",
    application_paid: "application paid",
    paid: "paid",
    refund_applied: "refund applied",
    refunded: "refunded",
  },
};
